import React, { useState } from 'react'
import styled, { css } from 'styled-components'
import { useSwipeable } from 'react-swipeable'
import SVG from 'react-inlinesvg'
import Arrow from '../../assets/svg/down.svg'

import BlogPostCard from '../BlogPostCard'

const StyledWrapper = styled.div`
  margin: 0 auto;
  max-width: 1029px;
  position: relative;
`

const StyledList = styled.ul`
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  left: 0;
  position: relative;
  transform: translate3d(
    ${({ activeItem }) => (activeItem === 0 ? '0' : `-${activeItem * 311}px`)},
    0,
    0
  );
  transition: transform 0.4s ease;
  width: ${({ dataLength }) => dataLength * 311}px;

  > li {
    opacity: 0.2;
    pointer-events: none;
  }

  > li:nth-child(${({ activeItem }) => activeItem + 1}) {
    opacity: 1;
    pointer-events: auto;
  }

  ${({ theme }) => theme.media.tablet} {
    > li:nth-child(${({ activeItem }) => activeItem + 1}),
    > li:nth-child(${({ activeItem }) => activeItem + 2}) {
      opacity: 1;
      pointer-events: auto;
    }
  }

  ${({ theme }) => theme.media.desktop} {
    transform: translate3d(
      ${({ activeItem }) =>
        activeItem === 0 ? '0' : `-${activeItem * 351}px`},
      0,
      0
    );
    width: ${({ dataLength }) => dataLength * 351}px;

    > li:nth-child(${({ activeItem }) => activeItem + 1}),
    > li:nth-child(${({ activeItem }) => activeItem + 2}),
    > li:nth-child(${({ activeItem }) => activeItem + 3}) {
      opacity: 1;
      pointer-events: auto;
    }
  }
`

const StyledListItem = styled.li`
  padding: 0 24px 0 0;
  transition: all 0.4s ease;
  width: 308px;

  main {
    height: initial;
  }

  ${({ theme }) => theme.media.desktop} {
    width: 350px;
  }
`

const StyledArrow = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 50%;
  box-shadow: 0 3px 3px -1px rgba(10, 22, 70, 0.1),
  0 0 1px 0 rgba(10, 22, 70, 0.06);
  cursor: pointer;
  display: none;
  height: 48px;
  justify-content: center;
  position: absolute;
  top: 200px;
  width: 48px;

  .isvg {
    svg {
      path {
        fill: #697788;
      }
    }
  }

  ${({ dir }) =>
    dir === 'prev'
      ? css`
          display: ${({ activeItem, dataLength }) =>
            activeItem === 0 ? 'none' : 'flex'};
          left: -14px;
          z-index: 2000;

          .isvg {
            transform: rotate(90deg);
          }

          ${({ theme }) => theme.media.tablet} {
            display: ${({ activeItem }) =>
              activeItem === 0 ? 'none' : 'flex'};
            left: -60px;
          }

          ${({ theme }) => theme.media.desktop} {
            left: -94px;
          }
        `
      : css`
          display: ${({ activeItem, dataLength }) =>
            activeItem === dataLength - 1 ? 'none' : 'flex'};
          left: 295px;

          .isvg {
            transform: rotate(-90deg);
          }

          ${({ theme }) => theme.media.tablet} {
            display: ${({ activeItem, dataLength }) =>
              activeItem === dataLength - 2 ? 'none' : 'flex'};
            left: 610px;
          }

          ${({ theme }) => theme.media.desktop} {
            display: ${({ activeItem, dataLength }) =>
              activeItem === dataLength - 3 ? 'none' : 'flex'};
            left: auto;
            right: -94px;
          }
        `}
`

const SlickArrow = ({ dir, activeItem, dataLength, onClick }) => (
  <StyledArrow
    dir={dir}
    activeItem={activeItem}
    dataLength={dataLength}
    onClick={onClick}
  >
    <SVG src={Arrow} />
  </StyledArrow>
)

const BlogPostSlider = ({ data }) => {
  const [activeItem, setActiveItem] = useState(0)
  const handlers = useSwipeable({
    onSwiped: event => {
      event.dir === 'Right' && setPrevSlide()
      event.dir === 'Left' && setNextSlide()
    },
    config: {
      delta: 10,
      preventDefaultTouchmoveEvent: false,
      trackTouch: true,
      trackMouse: true,
      rotationAngle: 0,
    },
  })

  const setNextSlide = () => {
    activeItem !== data.length - 1 && setActiveItem(activeItem + 1)
  }

  const setPrevSlide = () => {
    activeItem !== 0 && setActiveItem(activeItem - 1)
  }

  return (
    <StyledWrapper>
      <StyledList
        activeItem={activeItem}
        dataLength={data.length}
        {...handlers}
      >
        {data.map(post => (
          <StyledListItem key={post.id}>
            <BlogPostCard 
              noExcerpt={true} 
              data={post} 
              blogSlider={true} 
            />
          </StyledListItem>
        ))}
      </StyledList>
      <SlickArrow
        dir="next"
        activeItem={activeItem}
        dataLength={data.length}
        onClick={() => setNextSlide()}
      />
      <SlickArrow
        dir="prev"
        activeItem={activeItem}
        dataLength={data.length}
        onClick={() => setPrevSlide()}
      />
    </StyledWrapper>
  )
}

export default BlogPostSlider
